import React from "react";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import groupBy from "lodash/groupBy";

import { Card, Grid, Space } from "@masterteam/mt-design-react";

import Year from "./Year";

import "./style.scss";

const { Row } = Grid;

function MeasuresTable({ item = {} }) {
  function generateData() {
    const measures = item?.KPIMeasures?.map((e) => ({
      ...e,
      year: e?.DueDate
        ? Number(moment(e?.DueDate).locale("en").format("YYYY"))
        : null,
      month: e?.DueDate
        ? Number(moment(e?.DueDate).locale("en").format("MM"))
        : null
    }));

    const grouped = groupBy(measures, "year");
    let groupedList = Object.entries(grouped)?.map(([key, arr]) => ({
      Year: key,
      Data: arr?.sort((a, b) => a?.month - b?.month)
    }));

    // switch (item?.Frequency) {
    //   case "quarterly": {
    //     groupedList = groupedList?.map((yearData) => {
    //       if (yearData?.Data?.length === 4) return yearData;

    //       const obj = { ...yearData };
    //       const arr = [];
    //       let month = obj?.Data?.[0]?.month;
    //       // if (obj?.Data?.length !== 4) {
    //       //   while (month > 3) {
    //       //     month -= 3;
    //       //     arr.unshift({
    //       //       Target: "",
    //       //       Value: "",
    //       //       Variance: "",
    //       //       month,
    //       //     });
    //       //   }
    //       //   obj.Data = arr.concat(obj?.Data);
    //       // }
    //       return obj;
    //     });
    //     break;
    //   }

    //   case "monthly": {
    //     groupedList = groupedList?.map((yearData) => {
    //       if (yearData?.Data?.length === 12) return yearData;

    //       const obj = { ...yearData };
    //       const arr = [];
    //       let month = obj?.Data?.[0]?.month;
    //       // if (obj?.Data?.length !== 12) {
    //       //   while (month > 1) {
    //       //     month -= 1;
    //       //     arr.unshift({
    //       //       Target: "",
    //       //       Value: "",
    //       //       Variance: "",
    //       //       month,
    //       //     });
    //       //   }
    //       //   obj.Data = arr.concat(obj?.Data);
    //       // }
    //       return obj;
    //     });

    //     break;
    //   }

    //   default:
    //     break;
    // }

    groupedList = groupedList?.map((yearData) => {
      if (yearData?.Data?.length === 12) return yearData;

      const obj = { ...yearData };
      const arr = [];
      let month = obj?.Data?.[0]?.month;
      // if (obj?.Data?.length !== 12) {
      //   while (month > 1) {
      //     month -= 1;
      //     arr.unshift({
      //       Target: "",
      //       Value: "",
      //       Variance: "",
      //       month,
      //     });
      //   }
      //   obj.Data = arr.concat(obj?.Data);
      // }
      return obj;
    });

    return groupedList;
  }

  const data = generateData();

  return (
    <Card className="measures-table">
      <Space className="measures-table__header">
        <FormattedMessage id="kpi-details.measures-table-title" />
      </Space>
      <Row className="measures-table__content">
        <Space
          className="measures-table__content__side-cols"
          direction="vertical"
          gap={0}
          style={{
            paddingTop: "60px"
          }}
        >
          <Space className="measures-table__content__side-cols__col">
            <FormattedMessage id="measures-table.target" />
          </Space>
          <Space className="measures-table__content__side-cols__col">
            <FormattedMessage id="measures-table.actual" />
          </Space>
          <Space className="measures-table__content__side-cols__col">
            <FormattedMessage id="measures-table.variance" />
          </Space>
        </Space>
        <Space className="measures-table__content__years" gap={0}>
          {data?.map((year) => (
            <Year
              data={year}
              frequency={
                item?.Frequency === "custom" ? item?.Frequency : "monthly"
              }
              statuses={item?.KPIType?.Status}
              HasNoTargetBaseline={item?.HasNoTarget || item?.HasNoBaseline}
            />
          ))}
        </Space>
      </Row>
    </Card>
  );
}

export default MeasuresTable;
